<template>
  <div class="dict-select-wrapper">
    <a-select
      v-model="propsModel.value"
      :placeholder="propsModel.placeholder"
      :size="propsModel.size"
      @change="handleChange"
      style="width: 100%"
    >
      <a-select-option v-for="item in dictOptions" :value="item.itemValue">
        {{ item[fieldKey] }}
      </a-select-option>
    </a-select>
  </div>
</template>
<script>
import dict from './dict-mixin-extend'
export default {
  mixins: [dict],
  props: {
    dictCode: {
      type: String,
      default: undefined,
    },
    value: {
      type: [String, Number],
      default: undefined,
    },
    size: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: undefined,
    },
    begin: {
      type: Array,
      default: () => [],
    },
    end: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    propsModel() {
      return { ...this.$props }
    },
    dictOptions() {
      const { dictCode } = this
      const list = [...this.transformList(this.begin), ...this.getDictList(dictCode), ...this.transformList(this.end)]
      return list
    },
  },
  methods: {
    transformList(list) {
      list.forEach((item) => {
        item.itemValue = item.value
        item.itemTextEn = item.labelEn
        item.itemTextEs = item.labelEs
        item.itemText = item.label
      })

      return list
    },
    handleChange(val) {
      this.$emit('input', val)
      this.$emit('change', val)
    },
  },
}
</script>
<style lang="less" scoped>
.dict-select-wrapper {
  width: 100%;
}
</style>
